/** JWT 存取 + "需要登录"信号。AuthModal 订阅 useAuthStore 弹窗，登录成功后 resolve 等待方。 */
import { create } from 'zustand';

const TOKEN_KEY = 'h5:token';

export function getToken(): string | null {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(token: string | null) {
  try { token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
}

interface AuthState {
  open: boolean;
  resolvers: ((ok: boolean) => void)[];
  /** 请求登录：返回 Promise，用户登录成功 → true，选择离线 → false */
  request(): Promise<boolean>;
  finish(ok: boolean): void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  open: false,
  resolvers: [],
  request() {
    return new Promise<boolean>((resolve) => {
      set((s) => ({ open: true, resolvers: [...s.resolvers, resolve] }));
    });
  },
  finish(ok) {
    const { resolvers } = get();
    set({ open: false, resolvers: [] });
    resolvers.forEach((r) => r(ok));
  },
}));

export function requestLogin(): Promise<boolean> {
  return useAuthStore.getState().request();
}
